<an-base-modal (onCloseModal)="closeModal()">
  <div class="an-base-tooltip-modal">
    <div class="an-base-tooltip-modal__title"> {{ data?.title }} </div>
    <div class="an-base-tooltip-modal__message"> {{ data?.message }} </div>
  </div>
</an-base-modal>